module.exports = __webpack_public_path__ + "img/h_s1e1_interactions_3.0ed47e5e.png";